import { render } from "./_LayoutSidebar.vue?vue&type=template&id=93001734&scoped=true"
import script from "./_LayoutSidebar.vue?vue&type=script&lang=js"
export * from "./_LayoutSidebar.vue?vue&type=script&lang=js"

import "./_LayoutSidebar.vue?vue&type=style&index=0&id=93001734&scoped=true&lang=css"

import exportComponent from "C:\\Users\\esteb\\Desktop\\PlantillaEsteban\\fronted-plantilla\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93001734"]])

export default __exports__